import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle, FileText, Users, GitBranch, Sparkles, Send, PieChart } from 'lucide-react';

const faq = [
  { q: "Comment créer un fournisseur ?", a: "Allez dans le menu Fournisseurs, cliquez sur 'Nouveau fournisseur' et remplissez les informations. Le SIRET, l'IBAN et le BIC sont importants pour la generation des fichiers SEPA.", icon: Users },
  { q: "Comment saisir une facture fournisseur ?", a: "Dans le menu Factures, cliquez 'Nouvelle facture'. Sélectionnez le fournisseur, renseignez les informations de la facture et ajoutez les lignes de detail. Vous pouvez aussi utiliser l'import par IA pour pre-remplir automatiquement.", icon: FileText },
  { q: "Comment fonctionne le workflow de validation ?", a: "Chaque facture soumise suit un parcours de validation configurable. Allez dans Administration > Workflows pour configurer les étapes. Chaque étape definit un role ou un utilisateur qui doit approuver. Les validateurs reçoivent une notification et peuvent approuver, rejeter ou demander une modification.", icon: GitBranch },
  { q: "Comment utiliser la lecture IA ?", a: "Sur la page Factures, cliquez 'Importer par IA'. Uploadez un PDF ou une image de facture. L'IA (Claude ou OpenAI, configure par l'admin) extrait automatiquement les informations : fournisseur, montants, lignes de detail. Vérifiez et corrigez si besoin avant de valider.", icon: Sparkles },
  { q: "Comment générer un fichier SEPA ?", a: "1. Configurez vos comptes bancaires dans Administration > Comptes bancaires. 2. Dans la page Factures, filtrez les factures validees non payees. 3. Sélectionnez les factures a payer. 4. Cliquez 'Generer XML SEPA'. Le fichier XML (pain.001.001.03) est téléchargeable et peut être importe dans votre logiciel bancaire.", icon: Send },
  { q: "Comment fonctionne la comptabilité analytique ?", a: "Allez dans le menu Analytique. Créez d'abord des axes (ex: Centre de cout, Projet). Pour chaque axe, ajoutez des valeurs (ex: Marketing, IT, R&D). Ensuite, sur chaque facture, vous pouvez imputer les montants par axe en définissant des pourcentages de répartition.", icon: PieChart },
  { q: "Comment créer un avoir ?", a: "Sur la page d'une facture existante ou dans le menu Avoirs, vous pouvez creer un avoir qui fait reference a la facture d'origine. Les montants de l'avoir viennent en déduction du solde du fournisseur.", icon: FileText },
  { q: "Comment exporter mes donnees ?", a: "Sur la page Rapports, chaque onglet propose des boutons d'export CSV et Excel. Vous pouvez filtrer par date et exporter les donnees correspondantes.", icon: FileText },
];

export default function Help() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="text-center">
        <HelpCircle className="w-12 h-12 mx-auto mb-4 text-[#0F5156]" />
        <h1 className="text-2xl font-bold">Centre d'aide</h1>
        <p className="text-slate-500">Questions frequentes sur Nexus Compta</p>
      </div>

      <Card>
        <CardContent className="pt-6">
          <Accordion type="single" collapsible className="w-full">
            {faq.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`}>
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-3">
                    <item.icon className="w-5 h-5 text-[#0F5156] flex-shrink-0" />
                    <span>{item.q}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 dark:text-slate-300 pl-8">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6 text-center">
          <p className="text-slate-500">Besoin d'aide supplementaire ?</p>
          <p className="text-sm text-slate-400 mt-1">Contactez le support a <strong>support@nexus-compta.fr</strong></p>
        </CardContent>
      </Card>
    </div>
  );
}
